import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'

import project from 'EurestoConfig/project.config'
import Grid from '@material-ui/core/Grid'
import Modal from 'Components/Modal'
import Paper from '@material-ui/core/Paper'
import DataComponent from 'EurestoComponents/DataComponents'
import Constants from 'EurestoFonction/Constants'
import Input from 'Components/Input'
import Data from 'EurestoClass/Data'

import Hidden from '@material-ui/core/Hidden'


import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = { data: undefined, key: Utils.getRandomNumber() }
  }

  async componentDidMount () {
    let paramsSend = { 'requete': 'user', 'action': 'info' }

    const r = await ApiRequest(project.api + 'crm', paramsSend)

    if (r && r.code === 1) {
      const etablissement = await ApiRequest(project.api + 'crm', {
        requete: 'etablissement',
        action: 'information',
        id: r.info.entite.id
      })
      if (etablissement && etablissement.code === 1) {

        const relations = await ApiRequest(project.api + 'crm', {
          requete: 'relation',
          action: 'list',
        })
        if (relations && relations.code === 1) {
          Data.set(Constants.module.CRM, Constants.donnee.relation, relations.results)
          Data.set(Constants.module.COMMUN, Constants.donnee.civilite, [
            { id: 1, libelle: 'Monsieur', actif: 1, type: 1 },
            { id: 2, libelle: 'Madame', actif: 1, type: 1 }
          ])
          this.setState({
            data: etablissement.results,
            key: Utils.getRandomNumber(),
          })
        }
      }
    }
  }

  handleIconContactChange = (data, name) => {
    this.setState({
      data: {
        ...this.state.data,
        [name]: data,
      },
    })
  }

  onSaveRelation = async () => {
    const result = await ApiRequest(project.api + 'crm', {
      requete: 'contact',
      action: 'relations',
      relations: this.state.data.relations,
      id: this.state.data.id
    })

    this.setState({
      ended: true
    })

  }

  render () {
    return (
      this.state.data &&
      <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0, height: '100vh' }}
            justify={'center'}
            alignContent={'flex-start'} alignItems={'center'}>
        <i style={{ position: 'fixed', top: 32, right: 10, fontSize: 20 }} onClick={this.onSaveRelation}
           className={'fa fa-save EurestoSecondary EurestoPrimary--text btn'}> Enregistrer</i>

        <Hidden mdUp>
          <i onClick={this.newCardRelation}
             style={{ position: 'absolute', top: 80, left: 'calc(100vw / 2 - 20px )', fontSize: 20, zIndex: 1 }}
             className={'ei-commun_ajouter EurestoPrimary--text EurestoSecondary btn'}/>
        </Hidden>
        <Hidden smDown>
          <i onClick={this.newCardRelation}
             style={{ position: 'absolute', top: 80, left: 'calc(100vw / 2 - 200px )', fontSize: 20, zIndex: 301 }}
             className={'ei-commun_ajouter EurestoPrimary--text EurestoSecondary btn'}> Ajouter un nouveau contact avec sa
            relation</i>
        </Hidden>
        <Grid item xs={12} style={{ margin: 0, padding: 0, height: 100 }} className={'EurestoPrimary'}>
          <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0, paddingTop: 7.5 }}
                justify={'flex-start'}
                alignContent={'center'} alignItems={'center'}>
            <Grid item style={{ margin: 0, padding: 0, minWidth: 80, marginRight: 10, marginLeft: 20 }}
                  className={'EurestoPrimary'}>
              <DataComponent
                onChange={this.handleIconContactChange}
                key={this.state.key.picture}
                name="picture"
                avatarStyle={{ borderRadius: 0, width: 70, height: 70, }}
                disabled={false}
                data={this.state.data.picture}
                type={Constants.typeSaisie.Picture}
                defineData={true}
                object={{
                  picture: this.state.data.picture || { id: undefined, lien: undefined },
                  id: this.state.data.id,
                }}/>
            </Grid>

            <Hidden smDown>
              <Grid item style={{ margin: 0, padding: 0, marginRight: 10 }}>
                <h2 className={'EurestoText--text'}>{this.state.data.libelle}</h2>
                <label className={'EurestoText--text'}>{this.state.data.email}</label><br/>
                <label className={'EurestoText--text'}>{this.state.data.fixe}</label>
              </Grid>
              {/*<Grid item style={{ margin: 0, padding: 0, marginTop: 15 }} className={'EurestoPrimary'}>
                <label className={'EurestoText--text'}>Accepter de recevoir de notre part des :<br/>
                  <Checkbox onChange={this.handleIconContactChange} value={this.state.data.exclusEmailing}
                            name={'exclusEmailing'}/> Emails <br/>
                  <Checkbox onChange={this.handleIconContactChange} value={this.state.data.exclusSms}
                            name={'exclusSms'}/> SMS</label>
              </Grid>*/}
            </Hidden>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{
          margin: 0,
          padding: 20,
          height: 'calc(100vh - 200px)',
          maxHeight: 'calc(100vh - 200px)',
          overflow: 'auto',
          overflowX: 'hidden',
          position: 'relative'
        }} id={'main-page'}>
          <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0, paddingTop: 5 }}
                justify={'flex-start'}
                alignContent={'flex-start'} alignItems={'center'}>
            {
              (this.state.data.relations || []).map(this.RelationCard)
            }
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 5, height: 150 }}>
          </Grid>
        </Grid>
        <Grid item xs={12} style={{ margin: 0, padding: 0, backgroundColor: '#D9D9D9' }}>
          <Grid container spacing={0} style={{ margin: 0, padding: 0, maxHeight: 100 }}
                justify={'center'} alignContent={'center'} alignItems={'center'}>
            <Grid item xs={12} style={{ margin: 0, padding: 10 }}>
              <Grid container spacing={0} style={{ margin: 0, padding: 0 }}
                    justify={'center'}
                    alignContent={'center'} alignItems={'center'}>
                <p style={{ textAlign: 'justify', paddingTop: 15, maxHeight: 100 }}> Lorem ipsum dolor sit amet,
                  consectetur adipiscing
                  elit. Nam ut
                  consectetur massa. Duis pretium
                  dignissim
                  pretium. Sed cursus, magna pharetra consequat congue, erat nibh dapibus eros, finibus pretium metus
                  quam
                  rhoncus nunc. Curabitur ut ex viverra, congue elit pharetra, placerat velit. Cras in tincidunt justo.
                  Nunc
                  faucibus feugiat dui, eget ultricies odio suscipit a. In egestas elementum lorem.

                  Fusce molestie purus dignissim, sagittis erat in, consectetur elit. Ut in dolor vitae libero pretium
                  ultricies a sit amet urna. Sed aliquam sed urna ultricies vestibulum. Pellentesque vel consequat
                  magna,
                  nec
                  finibus massa. Suspendisse et lectus ultricies, faucibus metus sit amet, pharetra turpis. Vestibulum
                  laoreet
                  diam aliquet, bibendum ante id, elementum velit. Vivamus et eros sit amet mi porta volutpat. Nunc
                  ornare
                  semper libero vel convallis.

                  Nulla vel est finibus, aliquam tellus non, imperdiet justo. Vivamus gravida odio nisi. Integer vel
                  odio
                  quis
                  ante dapibus fringilla et vitae enim. Sed pellentesque ac eros eu finibus. Duis sed blandit risus.
                  Aenean
                  eget lacus non leo consequat bibendum. Etiam dolor massa, varius id felis at, hendrerit sollicitudin
                  tellus.
                  Phasellus in purus maximus, mollis massa eget, aliquet metus. Vivamus erat est, laoreet quis lectus
                  sed,
                  tempus tristique erat. </p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Modal open={this.state.ended} onEscapeKeyDown={() => this.setState({ ended: false })}>
          <Grid key={this.state.key} container spacing={0}
                style={{ margin: 0, padding: 0, height: 'calc( 100vh - 20% )', width: 'calc( 100vw - 20% )' }}
                justify={'center'}
                alignContent={'center'} alignItems={'center'}>
            Merci pour votre participation.
          </Grid>
        </Modal>
      </Grid>
      || <div/>
    )
  }

  newCardRelation = () => {
    const etablissement = this.state.data

    const newIndex = etablissement.relations.findIndex(r => r.archive)
    etablissement.relations.push({
      contact_id: undefined,
      contact_libelle: '',
      contact_sid: undefined,
      contact_pid: etablissement.id,
      relation_id: undefined,
      civilite_id: undefined,
      commentaire: '',
      nom: '',
      prenom: '',
      email: '',
      portable: '',
      fixe: '',
      archive: false,
      archive_action: '',
      archive_commentaire: '',
      key: Utils.getRandomNumber()
    })

    if (newIndex) {
      etablissement.relations.move(etablissement.relations.length - 1, newIndex)
    }

    this.setState({
      data: etablissement,
      //key: Utils.getRandomNumber()
    }, () => {
      var objDiv = document.getElementById('main-page')
      objDiv.scrollTop = objDiv.scrollHeight
    })
  }

  removeCard = (i) => _ => {
    const etablissement = this.state.data

    etablissement.relations[i] = {
      ...etablissement.relations[i],
      archive: true,
      archive_action: 'new',
      archive_commentaire: ''
    }

    this.setState({
      data: etablissement,
      //key: Utils.getRandomNumber()
    })
  }

  cancelRemove = (i) => _ => {
    const etablissement = this.state.data

    etablissement.relations[i] = {
      ...etablissement.relations[i],
      archive: false,
      archive_action: '',
      archive_commentaire: '',
      key: Utils.getRandomNumber()
    }

    this.setState({
      data: etablissement,
      //key: Utils.getRandomNumber()
    })
  }

  removeRelation = (i) => _ => {
    const etablissement = this.state.data

    etablissement.relations.splice(i, 1)

    this.setState({
      data: etablissement,
      //key: Utils.getRandomNumber()
    })
  }

  registerArchiveRelation = (i) => _ => {
    const etablissement = this.state.data

    etablissement.relations[i] = {
      ...etablissement.relations[i],
      archive_action: 'add',
    }

    etablissement.relations.move(i, etablissement.relations.length)

    this.setState({
      data: etablissement,
      key: Utils.getRandomNumber()
    })
  }

  onChangeRelation = (i) => (data, name) => {
    const etablissement = this.state.data

    etablissement.relations[i] = {
      ...etablissement.relations[i],
      [name]: data
    }

    this.setState({
      data: etablissement,
    })
  }

  handleImage = (i) => (d, da, db) => {
    const etablissement = this.state.data

    etablissement.relations[i] = {
      ...etablissement.relations[i],
      media_id: d.id,
      media_lien: d.lien
    }

    this.setState({
      data: etablissement,
    })
  }

  RelationCard = (relation, i) => (
    <Grid item lg={3} md={4} sm={6} xs={12} style={{ margin: 0, padding: 20, position: 'relative' }}
          key={i + '-' + relation.key}>
      {relation.archive !== true &&
      <Paper style={{ right: 20, position: 'absolute', top: 7.5, zIndex: 300, border: '1px dashed #FF0000' }}>
        <i onClick={!relation.archive && (relation.contact_id && this.removeCard(i) || this.removeRelation(i))}
           className={'ei-commun_fermer EurestoError--text btn ' + (relation.archive && 'disabled' || '')}>{relation.contact_id && 'Archiver' || 'Supprimer'}</i>
      </Paper>
      }
      <Paper style={{ position: 'relative' }}>
        {relation.archive && relation.archive_action === 'new' && this.createNewArchive(relation, i)
        || relation.archive && this.archive(relation, i) || ''
        }
        <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 10 }}
              justify={'center'}
              alignContent={'center'} alignItems={'flex-start'}>
          <Grid item style={{ margin: 0, padding: 0, height: 60, minWidth: 80 }}>
            <Paper style={{ left: 7.5, position: 'absolute', top: -10 }}>
              <DataComponent
                disabled={relation.archive === 1 || relation.archive}
                onChange={this.handleImage(i)}
                key={this.state.key.media_id}
                name="picture"
                avatarStyle={{ borderRadius: 0, width: 70, height: 70, }}
                type={Constants.typeSaisie.Picture}
                defineData={true}
                object={{
                  picture: relation.media_id && {
                    id: relation.media_id,
                    lien: relation.media_lien
                  } || { id: undefined, lien: undefined },
                  id: this.state.data.id,
                }}/>
            </Paper>
          </Grid>
          <Grid item xs style={{ margin: 0, padding: 0 }}>
            <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0 }}
                  justify={'center'} direction={'column'}
                  alignContent={'center'} alignItems={'stretch'}>
              <DataComponent
                consoleMe={true}
                title={EurestoI18n.t('crm:Civilité')}
                inline={true}
                name="civilite_id"
                disabled={relation.archive}
                key={relation.civilite_id}
                onChange={this.onChangeRelation(i)}
                type={Constants.typeSaisie.AutoComplete}
                data={relation.civilite_id}
                object={Constants.donnee.civilite}
                module={Constants.module.COMMUN}
                search={{ type: 1 }}
              />
              <Input
                type="text"
                className="upText"
                title={'Nom'}
                inline={true}
                disabled={relation.archive}
                name={'nom'}
                onChange={this.onChangeRelation(i)}
                value={relation.nom}
              />
              <Input
                type="text"
                inline={true}
                className="upText"
                title={'Prénom'}
                name={'prenom'}
                disabled={relation.archive}
                onChange={this.onChangeRelation(i)}
                value={relation.prenom}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
            <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 0 }}
                  justify={'center'} direction={'column'}
                  alignContent={'center'} alignItems={'stretch'}>
              <Input
                type="text"
                className="upText"
                title={'Email'}
                name={'email'}
                inline={true}
                disabled={relation.archive}
                onChange={this.onChangeRelation(i)}
                value={relation.email}
              />
              <Input
                type="text"
                className="upText"
                title={'Fixe'}
                name={'fixe'}
                inline={true}
                disabled={relation.archive}
                onChange={this.onChangeRelation(i)}
                value={relation.fixe}
              />
              <Input
                type="text"
                className="upText"
                title={'Portable'}
                name={'portable'}
                inline={true}
                disabled={relation.archive}
                onChange={this.onChangeRelation(i)}
                value={relation.portable}
              />
              <DataComponent
                title={EurestoI18n.t('crm:Relation')}
                key={relation.relation_id}
                name="relation_id"
                inline={true}
                disabled={relation.archive}
                onChange={this.onChangeRelation(i)}
                type={Constants.typeSaisie.AutoComplete}
                data={relation.relation_id}
                object={Constants.donnee.relation}
                module={Constants.module.CRM}
              />
            </Grid>

          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )

  createNewArchive = (relation, i) => (
    <Grid key={this.state.key} container spacing={0}
          style={{ margin: 0, padding: 10, position: 'absolute', zIndex: 1000 }}
          justify={'center'}
          alignContent={'center'} alignItems={'center'}>
      <Paper style={{ position: 'relative', backgroundColor: 'rgba(#FFFFFF,.8)', height: 130, width: 'calc(100% - 10px)' }}>
        <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 10 }}
              justify={'center'}
              alignContent={'center'} alignItems={'center'}>
          <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
            <Input
              type="text"
              multi
              rows={4}
              rowsMax={4}
              className="upText"
              title={'Motif archivage'}
              name={'archive_commentaire'}
              onChange={this.onChangeRelation(i)}
              value={relation.archive_commentaire}
            />
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 0 }}>
            <i onClick={this.cancelRemove(i)}
               className={'ei-commun_fermer EurestoError--text EurestoSecondary btn'}>Annuler</i>
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 0 }}>
            <i onClick={this.registerArchiveRelation(i)}
               className={'ei-commun_valider EurestoSecondary--text EurestoPrimary btn'}>Valider</i>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )

  archive = (relation, i) => (
    <Grid key={this.state.key} container spacing={0}
          style={{ margin: 0, padding: 10, position: 'absolute', zIndex: 1000 }}
          justify={'center'}
          alignContent={'center'} alignItems={'center'}>
      <Paper style={{ position: 'relative', backgroundColor: '#efefef', height: 130, width: 'calc(100% - 10px)' }}>
        <Grid key={this.state.key} container spacing={0} style={{ margin: 0, padding: 10 }}
              justify={'center'}
              alignContent={'center'} alignItems={'center'}>
          <Grid item xs={12} style={{ margin: 0, padding: 0 }}>
            <Grid container spacing={0} style={{ margin: 0, padding: 0 }}
                  justify={'center'}
                  alignContent={'center'} alignItems={'center'}>
              <Input
                type="text"
                multi
                readOnly={true}
                rows={4}
                rowsMax={4}
                inline
                className="text-center"
                style={{ textAlign: 'center', background: '#efefef' }}
                title={'Motif archivage'}
                name={'archive_commentaire'}
                onChange={this.onChangeRelation(i)}
                value={relation.archive_commentaire}
              />
            </Grid>
          </Grid>
          <Grid item xs={3} style={{ margin: 0, padding: 0 }}>
            <i onClick={this.cancelRemove(i)}
               className={'ei-commun_fermer EurestoError--text EurestoSecondary btn'}>Annuler</i>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  )

}





// WEBPACK FOOTER //
// ./app/App/Module/Page/Page/RelationEtablissement/index.js